import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

const CustomFileUploadInput = ({ title, acceptedFileTypes, onFileSelect }) => {
    const fileInputRef = React.useRef(null);
    const [dragOver, setDragOver] = useState(false);

    const handleDragOver = (e) => {
        e.preventDefault();
        setDragOver(true);
    };

    const handleDragLeave = () => setDragOver(false);

    const handleDrop = (e) => {
        e.preventDefault();
        setDragOver(false);
        const file = e.dataTransfer.files[0];
        if (file) onFileSelect(file);
    };

    const handleFileInputChange = (e) => {
        const file = e.target.files[0];
        if (file) onFileSelect(file);
    };

    return (
        <Box>
            <Typography variant="body2" sx={{ mb: 1, color: '#636363', fontWeight: 'bold' }}>
                {title}
            </Typography>

            <Box
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
                onClick={() => fileInputRef.current.click()}
                sx={{
                    border: '1px dashed #ccc',
                    borderRadius: 2,
                    padding: 2,
                    textAlign: 'center',
                    backgroundColor: dragOver ? '#f0f0f0' : '#fafafa',
                    cursor: 'pointer',
                }}
            >
                <CloudUploadIcon fontSize="large" sx={{ color: '#999' }} />
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Typography variant="body2" sx={{ mt: 1 }}>
                        Drag & drop file or <Typography variant="caption" size="small" sx={{ mt: 1, color: '#0081F2', fontWeight: 'bold', fontSize: '14px' }}>Browse Files </Typography>
                    </Typography>
                </Box>
                <Typography variant="body2" sx={{ color: '#999', mt: 1 }}>
                    PNG, JPG, JPEG, and PDF
                </Typography>
                <input
                    ref={fileInputRef}
                    type="file"
                    accept={acceptedFileTypes.join(',')}
                    hidden
                    onChange={handleFileInputChange}
                />
            </Box>
        </Box>
    );
};

export default CustomFileUploadInput;